const MAIN_CHAT_REQUEST_TYPES = new Set(["", "itinerary"]);
const MAX_TITLE_LENGTH = 255;

export function cleanChatTitle(value: any): string {
  const title = typeof value === "string" ? value.trim() : "";
  return title.length <= MAX_TITLE_LENGTH ? title : "";
}

export function getChatTitle(chat: any[] | undefined): string {
  return Array.isArray(chat) ? cleanChatTitle(chat[0]?.chatTitle) : "";
}

export function getHistoryTitle(row: any): string {
  return cleanChatTitle(row?.title) || getChatTitle(row?.history);
}

export function withChatTitle(chat: any[], title: any): any[] {
  const clean = cleanChatTitle(title);
  if (!clean || !Array.isArray(chat) || chat.length === 0 || getChatTitle(chat) === clean) return chat;
  return [{ ...chat[0], chatTitle: clean }, ...chat.slice(1)];
}

export function continuesMainChat(body: any): boolean {
  if (!body || typeof body !== "object" || !MAIN_CHAT_REQUEST_TYPES.has(body.requestType ?? "")) return false;
  return Array.isArray(body.messages) && body.messages.some((message: any) => message?.role === "assistant");
}
